import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKhronosgroupComponent } from './simple-icons-khronosgroup.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKhronosgroupComponent ],
    exports:      [ SimpleIconsKhronosgroupComponent ],
    bootstrap:    []
})
export class SimpleIconsKhronosgroupModule {}
